import { createSlice } from "@reduxjs/toolkit";
const minSize = process.env.REACT_APP_MIN_SIZE;
const maxSize = process.env.REACT_APP_MAX_SIZE;

const initialState = {
  data: [],
  selectMinMaxOfSize: [minSize, maxSize, minSize, maxSize],
  selectedVillages: [],
  loading: false,
  error: null,
};

const villageCount = createSlice({
  name: "villageCount",
  initialState,
  reducers: {
    fetchVillageCountDetailsStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchVillageCountDetailsSuccess(state, action) {
      console.log("fetchDataSuccess Village Count success");
      state.loading = false;

      const tempData = action.payload;
      state.data = tempData;
      console.log("Village Count details are", state.data);
      console.log("fetchDataSuccess VillageCount success data");
    },
    setSelectMinMaxOfSize(state, action) {
      state.loading = false;
      state.selectMinMaxOfSize = {
        ...state.selectMinMaxOfSize,
        ...action.payload,
      };
    },
    fetchSelectedVillages(state, action) {
        state.loading = false;
        state.selectedVillages = action.payload
        console.log("updated selected villages are ",state.selectedVillages)
      },
    fetchVillageCountDetailsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchVillageCountDetailsStart,
  fetchVillageCountDetailsSuccess,
  setSelectMinMaxOfSize,
  fetchSelectedVillages,
  fetchVillageCountDetailsFailure,
} = villageCount.actions;
export default villageCount.reducer;
